export default class MaillageFormations {
    constructor() {
        this.maillageFormations = document.querySelector('.maillage-formations');
        this.formationList = document.querySelector('#formationList');
    }

    init() {
        if (!this.maillageFormations) return;
        this.getMaillageFormation();
    }

    async getMaillageFormation() {
        const currentProductId = this.maillageFormations.dataset.productId;
        if (!currentProductId) {
            this.displayNull();
            return;
        }

        const formData = new FormData();
        formData.append('action', 'get_products_from_main_site');
        formData.append('current_product_id', currentProductId);

        try {
            const response = await fetch(this.maillageFormations.dataset.ajaxurl, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success && data.data.length > 0) {
                this.displayFormations(data.data);
            } else {
                this.displayNull();
                console.error('Erreur :', data.data?.message || 'Aucune donnée reçue');
            }
        } catch (error) {
            this.displayNull();
            console.error('Erreur AJAX :', error);
        }
    }

    displayFormations(formations) {
        if (!this.formationList || formations.length === 0) {
            this.displayNull();
            return;
        }

        // Affiche le bloc si des données existent
        this.maillageFormations.style.display = 'block';

        this.formationList.innerHTML = formations.map(formation => {
            const thematiques = formation.thematique.map(t => `<span class="thematique">${t}</span>`).join(', ');

            const qualifications = formation.qualification_details.map(q => {
                const color = q.color || '#f0f0f0';
                const name = q.name || '';
                return `
                    <div class="tag" style="background-color: ${color}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none">
                            <path fill="#1A1F2F" d="M12 9.75V.25L0 9.75h12Z"></path>
                        </svg> ${name}
                    </div>
                `;
            }).join('');

            return `
                <div class="swiper-slide">
                    <div class="product-item">
                        <div class="card card-formation">
                            <div class="qualif default">
                                ${qualifications}
                            </div>
                            <div class="card-content">
                                <div class="card-content-info">
                                    <div>
                                        <h3 class="title">
                                            <a href="${formation.permalink}" target="_blank">${formation.post_title}</a>
                                        </h3>
                                        <div class="product-thematiques">${thematiques}</div>
                                    </div>
                                    <div>
                                        <a href="${formation.permalink}" target="_blank" class="btn btn-dark"><span class="label">Découvrir la formation</span><svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" fill="none"><path stroke="#fff" stroke-width="1.5" d="m1 8 3.5-3.5L1 1"/></svg></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }).join('');
    }

    displayNull() {
        if (this.maillageFormations) {
            this.maillageFormations.remove();
        }
    }
}
